(function (){
  'use strict';

  angular.module('tfc.retailer.StandardReports')
      .directive('mainSublabelsTopCallout', mainSublabelsTopCallout)
      .controller('MainSublabelsTopCalloutCtrl', MainSublabelsTopCalloutCtrl);




  function mainSublabelsTopCallout() {
    return {
      restrict: 'E',
      scope : {
        mainLabel: '=',
        subLabels: '=',
        fetchData: '&'
      },
      templateUrl : 'StandardReports/Callout/MainSublabelsTopCallout.tmpl.html',
      controller : 'MainSublabelsTopCalloutCtrl as vm',
      bindToController: true
    };
  }

  //@ngInject
  function MainSublabelsTopCalloutCtrl(ConsumerChart){

    var vm = this;

    vm.fetchData().then(function (data) {
      vm.model = mainSublabelTopCalloutModel(
          vm.mainLabel,
          vm.subLabels,
          data
      );
    });


    function mainSublabelTopCalloutModel(mainLabel, subLabels, formattedData){

      var data =  _.reduce(_.concat(mainLabel, subLabels), function (result, label) {
        result[label.userCohort.value] = _.last(ConsumerChart.getChartData(
            formattedData.dateMetrics,
            {userCohort: label.userCohort.value, isBot: false}
            ));
        return result;
      },{});

      return {
        mainLabel: model(data, mainLabel),
        subLabels: _.map(subLabels, function (label) {
          return model(data, label)
        })
      };
    }

    function model(data, label) {
      return {
        label: label,
        value: data[label.userCohort.value] && data[label.userCohort.value].value
      }
    }

  }



})();